import { useEffect, useState } from 'react';
import CustomAppBar from '../../components/CustomAppBar';
import { Box, Card, CircularProgress, Container, Grid, IconButton, Typography, Button } from "@mui/material";
import { PlayArrowRounded, TrendingUp } from '@mui/icons-material';
import { connect, useDispatch } from 'react-redux';
import { homePageActions } from '../../store/reducer/home';
import { useNavigate } from 'react-router-dom';
import AlertBar from '../../components/AlertBar';
import { isEmpty } from 'lodash';
import { fatafatDollarActions } from '../../store/reducer/fatafat-dollar';
import { authActions } from '../../store/reducer/auth-reducer';

const FatafatDollar = ({ isFatafatDollarLoading, fatafatDollarGamesData, isFatafatDollarDataFailed, fatafatDollarMsg }: any) => {
    const userDataSession: any = localStorage.getItem('userData');
    const finalData = JSON.parse(userDataSession)

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [pageData, setPageData] = useState<any>([])
    const [errorMessage, setErrorMessage] = useState<any>({ status: false, message: '', severity: '', inputName: '' })
    const [currentTime, setCurrentTime] = useState(new Date())

    // Function to check if game is open based on time
    const isGameOpen = (closeTime: string) => {
        try {
            // Parse close time (format: "11:00 AM")
            const [time, period] = closeTime.split(' ');
            const [hours, minutes] = time.split(':').map(Number);
            
            // Convert to 24-hour format
            let closeHour = hours;
            if (period === 'PM' && hours !== 12) {
                closeHour += 12;
            } else if (period === 'AM' && hours === 12) {
                closeHour = 0;
            }
            
            // Get current time
            const now = new Date();
            const currentHour = now.getHours();
            const currentMinute = now.getMinutes();
            
            // Compare times
            if (currentHour > closeHour) {
                return false;
            } else if (currentHour === closeHour && currentMinute > minutes) {
                return false;
            }
            
            return true;
        } catch (error) {
            console.error('Error checking game time:', error);
            return true; // Default to open if error
        }
    }

    useEffect(() => {
        const data: any = {
            app_key: "@34Y@#8deepmatka",
        };
        dispatch(fatafatDollarActions.fatafatDollarGamesReq(data))
        const pay: any = {
            menuname: 'fatafat-dollar'
        }
        dispatch(homePageActions.selectedMenu(pay))
        dispatch(fatafatDollarActions.setFatafatDollarMenuName('Fatafat Dollar Games'))
        
        // Load wallet balance - same as Layout.tsx
        if (!isEmpty(finalData)) {
            const data: any = { "app_key": "@34Y@#8deepmatka", "user_id": finalData.user_id }
            dispatch(authActions.getUserDataReq(data))
            dispatch(authActions.getWalletBalanceReq(data))
        }

        // Update current time every minute to refresh game status
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 60000); // Update every minute

        return () => clearInterval(timer);
    }, [])

    useEffect(() => {
        console.log('🔍 Fatafat Dollar Debug:');
        console.log('fatafatDollarGamesData:', fatafatDollarGamesData);
        console.log('isEmpty:', isEmpty(fatafatDollarGamesData));
        console.log('has games:', fatafatDollarGamesData?.games);
        
        if (!isEmpty(fatafatDollarGamesData) && fatafatDollarGamesData.games) {
            console.log('✅ Setting page data with', fatafatDollarGamesData.games.length, 'games');
            setPageData(fatafatDollarGamesData.games)
        } else {
            console.log('❌ No games data available');
            console.log('Full data:', JSON.stringify(fatafatDollarGamesData, null, 2));
        }
    }, [fatafatDollarGamesData, isFatafatDollarLoading])

    const handleCardClick = (event: any, item: any) => {
        const gameOpen = isGameOpen(item.close_time);
        const marketOpen = item.market_status === '1' || item.market_status === 1;
        
        if (marketOpen && gameOpen) {
            navigate('/fatafat-dollar/game-list/' + item.game_id)
        } else {
            setErrorMessage({ status: true, message: "Game is closed for today.", severity: 'error', inputName: '' })
        }
    }

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setErrorMessage({ status: false, message: "", severity: "", inputName: '' })
    };

    return (
        <div>
            <CustomAppBar title={'Fatafat Dollar'} isBack={true} />
            {isFatafatDollarLoading ? 
                <div style={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}> 
                    <CircularProgress /> 
                </div> :
                <Container sx={{ paddingLeft: '0px !important', paddingRight: '0px !important', marginTop: '70px !important', paddingBottom: '50px' }}>
                    {/* Dollar Game Rate Button */}
                    <Box sx={{ padding: '10px', marginBottom: '10px' }}>
                        <Button
                            fullWidth
                            variant="contained"
                            startIcon={<TrendingUp />}
                            onClick={() => navigate('/fatafat-dollar/rates')}
                            sx={{
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                color: 'white',
                                padding: '15px',
                                fontSize: '1.1rem',
                                fontWeight: 'bold',
                                borderRadius: '15px',
                                boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 6px 20px rgba(102, 126, 234, 0.6)',
                                }
                            }}
                        >
                            💰 Dollar Game Rates
                        </Button>
                    </Box>
                    
                    <Grid container sx={{ display: 'flex', justifyContent: 'flex-start', padding: '5px' }}>
                        {(pageData.length) ? pageData.map((item: any, index: number) => (
                            <Grid xs={12} lg={3} md={4} sm={4} margin={1} key={index}>
                                <Card variant="outlined"
                                    onClick={(event: any) => handleCardClick(event, item)}
                                    sx={{
                                        borderRadius: '22px',
                                        boxShadow: '0px 0px 2px #adadad27',
                                        border: '0px solid transparent',
                                        padding: '5px',
                                        backgroundColor: '#ffff',
                                        cursor: 'pointer',
                                        '&:hover': {
                                            boxShadow: '0px 4px 12px rgba(0,0,0,0.15)',
                                            transform: 'translateY(-2px)',
                                            transition: 'all 0.3s'
                                        }
                                    }}>
                                    <Box sx={{ 
                                        display: 'flex', 
                                        color: (item.market_status === 1 || item.market_status === '1') ? '#5d5d5d' : '#5d5d5d', 
                                        padding: '10px 5px 10px 5px', 
                                        flexDirection: 'row', 
                                        justifyContent: 'space-between', 
                                        alignItems: 'center' 
                                    }}>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', padding: '0px 8px 0px 8px', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                                            <Typography sx={{ textAlign: 'center', color: 'inherit', fontFamily: 'calibri', fontSize: '1.8rem', fontWeight: '800', lineHeight: 1 }}>
                                                {item.game_name}
                                            </Typography>
                                            
                                            {/* Result Display */}
                                            {item.result_display && (
                                                <Box sx={{ marginTop: '8px', display: 'flex', flexDirection: 'row', paddingLeft: '5px', alignItems: 'center', justifyContent: 'center' }}>
                                                    <Typography sx={{ 
                                                        color: '#e91e63', 
                                                        fontFamily: 'monospace', 
                                                        fontSize: '1.2rem', 
                                                        fontWeight: '700', 
                                                        lineHeight: 1,
                                                        letterSpacing: '2px'
                                                    }}>
                                                        {item.result_display}
                                                    </Typography>
                                                </Box>
                                            )}
                                            
                                            <Box sx={{ marginTop: '8px', display: 'flex', flexDirection: 'row', paddingLeft: '5px', alignItems: 'center', justifyContent: 'center' }}>
                                                <Typography sx={{ color: 'inherit', fontFamily: 'calibri', fontSize: '0.9rem', fontWeight: '400', lineHeight: 1 }}>
                                                    Open: {item.open_time} - Close: {item.close_time}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <IconButton sx={{
                                            borderRadius: '18px', height: '100px', width: '100px', padding: 0,
                                            display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', boxShadow: '0px 0px 0px #adadad27'
                                        }}>
                                            {((item.market_status === 1 || item.market_status === '1') && isGameOpen(item.close_time)) ? 
                                                <Typography sx={{ fontSize: '9px', color: 'green', marginBottom: '5px', fontWeight: 'bold' }}>OPEN</Typography> : 
                                                <Typography sx={{ fontSize: '8px', color: 'red', marginBottom: '2px', fontWeight: 'bold' }}>Game closed Today</Typography>
                                            }
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '40px', width: '40px', borderRadius: '30px', backgroundColor: '#f8b12a' }}>
                                                <PlayArrowRounded sx={{ fontSize: '2rem' }} /> 
                                            </div>
                                            <Typography sx={{ fontSize: '8px', color: '#5d5d5d', marginBottom: '0px', marginTop: '5px' }}>Play game</Typography>
                                        </IconButton>
                                    </Box>
                                </Card>
                            </Grid>
                        )) : isFatafatDollarLoading ? '' : 
                            <Grid xs={12} sx={{textAlign: 'center', padding: '50px'}}>
                                <Typography>No games available</Typography>
                            </Grid>
                        }
                    </Grid>
                </Container>
            }
            <AlertBar handleClose={handleClose} errorMessage={errorMessage} />
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    isFatafatDollarLoading: state.fatafatdollar.isFatafatDollarLoading,
    fatafatDollarGamesData: state.fatafatdollar.fatafatDollarGamesData,
    isFatafatDollarDataFailed: state.fatafatdollar.isFatafatDollarDataFailed,
    fatafatDollarMsg: state.fatafatdollar.fatafatDollarMsg,
})

export default connect(mapStateToProps)(FatafatDollar);

